"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlatformUrl = exports.getAPIUrl = void 0;
function getAPIUrl() {
    return localStorage.getItem('API_URL') || getPlatformUrl();
}
exports.getAPIUrl = getAPIUrl;
function getPlatformUrl() {
    return process.env.REACT_APP_PLATFORM_URL
        ? process.env.REACT_APP_PLATFORM_URL
        : 'https://platform.grey-wing.com';
}
exports.getPlatformUrl = getPlatformUrl;
